module.exports = __webpack_public_path__ + "img/niagra_falls.393c702a.jpg";